import { classnames, fCredit, toPercent } from '@aibees/shared/utils';
import { Box, LinearProgress, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { Icon } from '../icon';
import * as Styled from './styles';
import * as SX from './sx';
import type { CreditProgressProps as Props } from './types';

export const CreditProgress = memo(
  ({ className, charged, type, remaining, showWarning }: Props) => {
    const subPercent = toPercent(remaining, charged);

    return (
      <Styled.Wrapper
        className={classnames('CreditProgress', className)}
        sx={SX.root}
      >
        <Styled.CreditValueWrapper>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            gap={1}
          >
            <Icon name="coin" color="primary.500" size={14} />
            <Typography variant="body4" fontWeight={600} color="grey.700">
              {type === 'Credit' ? 'Plan Credit' : 'Roll Over Credits'}
            </Typography>
          </Stack>
          <Styled.CreditValueNumberWrapper>
            <Typography
              sx={SX.consumedCreditText({
                isLow: showWarning && subPercent <= 5,
                isEmpty: showWarning && subPercent === 0,
              })}
              variant="body4"
            >
              {fCredit(remaining)}
            </Typography>
            /
            <Typography variant="body4" fontWeight={400} color="grey.500">
              {fCredit(charged)}
            </Typography>
          </Styled.CreditValueNumberWrapper>
        </Styled.CreditValueWrapper>
        <Box>
          <LinearProgress
            sx={{
              backgroundColor:
                subPercent === 0
                  ? (theme) => theme.palette.error[500]
                  : (theme) => theme.palette.grey[200],
              '& .MuiLinearProgress-bar': {
                backgroundColor:
                  showWarning && subPercent < 5
                    ? (theme) => theme.palette.warning[300]
                    : type === 'Credit'
                    ? (theme) => theme.palette.primary[500]
                    : (theme) => theme.palette.success.main,
              },
            }}
            variant="determinate"
            value={subPercent}
          />
        </Box>
      </Styled.Wrapper>
    );
  }
);

CreditProgress.displayName = 'CreditProgress';
